<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">作业管理</span>

                <el-tabs v-model="activeUniversityGroup" type="card" v-loading="loading">
                  <el-tab-pane name="1" v-if="hasUniversityCourse">
                    <span slot="label">大学补习</span>
                    <el-row class="grid-content">
                      <el-col>
                        <courseHomeworkList :courseType="1"></courseHomeworkList>
                      </el-col>
                    </el-row>
                  </el-tab-pane>

                  <!-- <el-tab-pane name="2">
                                    <span slot="label"> 应试英语 </span>
                                    <el-row class="grid-content">
                                        <el-col>
                                          
                                        </el-col>
                                    </el-row>
                  </el-tab-pane>-->

                  <el-tab-pane name="3" v-if="hasVocationalTrainingCourse">
                    <span slot="label">职业培训</span>
                    <el-row class="grid-content">
                      <el-col>
                        <courseHomeworkList :courseType="3"></courseHomeworkList>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
/* elementui 的tabs组件出现蓝色边框问题 */

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>

<script>
import navigator from "../../components/navigator";
import courseHomeworkList from "../../components/homework/courseHomeworkList";
import { checkUserCourseType } from "../../service/user.service";
import { getStore, setStore } from "../../config/mUtils";
import global_ from "../../core/global";

export default {
  data() {
    return {
      loading: true,
      activeUniversityGroup: "1",
      hasUniversityCourse: true,
      hasVocationalTrainingCourse: true,
    };
  },
  components: {
    navigator,
    courseHomeworkList,
  },
  computed: {},
  created() {
    if (this.USERMANAGER.isStudent || this.USERMANAGER.isTeacher) {
      this.loading = true;
      checkUserCourseType(true).then((result) => {
        if (result && result.success) {
          this.hasUniversityCourse = result.data.HasUniversityCourse;
          this.hasVocationalTrainingCourse =
            result.data.HasVocationalTrainingCourse;
          if (!this.hasUniversityCourse) {
            this.activeUniversityGroup = "3";
          }
        }
        this.loading = false;
      });
    }else if (this.USERMANAGER.isVocationalTrainingManager){
      this.hasUniversityCourse = false;
      this.activeUniversityGroup = "3";
      this.loading = false;
    }else{
      this.loading = false;
    }
    if (!!this.$route.query.courseType) {
      this.activeUniversityGroup = this.$route.query.courseType;
    }
  },
  methods: {},
  watch: {
    activeUniversityGroup: function () {},
  },
};
</script>



// WEBPACK FOOTER //
// src/page/homework/homeworkManage.vue